import { useEffect } from 'react';
import type { TFunction } from 'i18next';
import { setRsShareBoardTitle } from '../utils/reservationBoardSharePath.util';

/** document.title と共有バー表名を同期する */
export function useRsBoardDocumentTitle(
  boardName: string | undefined,
  shareToken: string,
  t: TFunction
): void {
  useEffect(() => {
    if (!boardName) return;
    const baseTitle = t('reservation.manager.title', { defaultValue: '予約システム' });
    document.title = `${boardName} | ${baseTitle}`;
    return () => {
      document.title = baseTitle;
    };
  }, [boardName, t]);

  useEffect(() => {
    if (!shareToken || !boardName) {
      setRsShareBoardTitle('');
      return;
    }
    setRsShareBoardTitle(boardName);
    return () => setRsShareBoardTitle('');
  }, [shareToken, boardName]);
}
